import { render, staticRenderFns } from "./other-property-information.vue?vue&type=template&id=5ba39387&scoped=true"
import script from "./other-property-information.vue?vue&type=script&lang=ts"
export * from "./other-property-information.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba39387",
  null
  
)

export default component.exports